export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9545.29530ee5.jpg";